/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260427
*/
'use strict';

import {
    bindSelect,
    getMoveIcon,
    getTableRows
} from './ctssHtml.js';
import {
    deleteImgFromCloudAsync,
    hasImgsToDelete,
    hasImgsToUpload,
    setHasImgsToDelete,
    setHasImgsToUpload,
    uploadImgToCloudAsync,
    uploadToImgCtrl
} from './ctssImg.js';

import {
    allSettled,
    deletePromise,
    getPromise,
    getSortKeysFromTableOrder,
    initDragDropTableSort,
    savePromise
} from './ctssJQuery.js';
import {
    isDataModified,
    missingRequiredData,
    phoneNumberInputMask,
    setModified,
    validEmail,
    validURL
} from './ctssVal.js';
import { saveChurchLogoAsync } from './snChurches.js'; 
import {
    appDebugMode,
    getAppToken,
    getImgsBaseURLAsync,
    getTestFolderParams,
    Features,
    ImgsFolder,
    setMenu
} from './snSite.js';

/* private functions */

const { useTestFolder, testFolderParam } = getTestFolderParams();

const token = getAppToken();

const cancelDefaultNewFeature = () => {
    const idx = churchFeatures.findIndex(x => x.id === '-1');
    if (idx > -1) { /* Remove element if new feature was added then cancelled */
        churchFeatures.splice(idx, 1);
    }
}

const deleteChurchFeatureAsync = async (params) => {
    await deletePromise({
        url: `ChurchFeatures/${token.CG}/${params.key}`,
        divErrMsg: 'divDelDlgErrMsg'
    }).then(() => {
        $('#deleteDlg').modal('hide');
        /* Just removing from page is faster than going to server to refresh */

        churchFeatures.splice(churchFeatures.findIndex(x => x.id === params.key), 1);
        $('#' + params.key).remove();
    });
}
const getChurchFeaturesDataAsync = async () =>
    await getPromise({ url: 'ChurchFeatures' });

const getChurchFeatureTitle = (key) =>
    churchFeatures[churchFeatures.findIndex(x => x.id === key)].title;

const getChurchFeatureRow = (params = {}) => {
    return '<tr id="' + params.data.id +
        '" data-displayOrder=" ' + params.data.displayOrder + '" >' +
        '<td class="col-sm-4">' + params.data.title + '</td>' +
        '<td class="col-sm-4"><img src="' +
        featureImgsBaseURL + params.data.imgName + '" class="img-responsive" ></td>' +
        '<td class="col-sm-4 text-right">' +
        '<span class="fa fa-pencil mRight10" title="Edit feature information..." data-toggle="modal" data-target="#updateDlg" data-key="' + params.data.id + '"></span>' +
        '<span class="fa fa-trash mRight10" title="Delete feature..." data-toggle="modal" data-target="#deleteDlg" data-key="' + params.data.id + '"></span>' +
        getMoveIcon() + '</td>' +
        '</tr>';
}

const getFeatureDefaultsAsync = async (featureID, imgSizeCode) => {
    //document.getElementById("loader").style.display = "block";
    const size = imgSizeCode === undefined ? '' : '&size=' + imgSizeCode;
    //let url = `${snSite.baseURL}/api/Features/ResetValues?id=${featureID}&templateID=${featuresTemplateID}${size}`;
    return await getPromise({
        url: `Features/Reset/${featureID}/${featuresTemplateID}${size}`
    })
}

const getFeaturesDataAsync = async () =>
    await getPromise({ url: 'Features' });


const getFeaturesTemplatesDataAsync = async () =>
    await getPromise({ url: 'FeatureTemplates' });

const initAddFeatureDlg = () => {
    $('#addFeatureDlg').on('show.bs.modal', (e) => {

        /* create array of app features not currently used by church */
        const availableFeatures = features
            .filter(f => churchFeatures.findIndex(x => x.featureID === f.id) === -1)
            .map(f => ({ id: f.id, title: f.title }));

        availableFeatures.push({ id: 0, title: 'Custom Feature' });
        bindSelect({
            id: 'ddlFeature', items: availableFeatures, valueNm: 'id', textNm: 'title'
        });
    });
    $('#btnNewFeature').on('click', async () => {
        try {
            const featureID = $('#ddlFeature').val();
            const data = await getFeatureDefaultsAsync(featureID);
            churchFeatures.push({
                id: "-1",
                cg: null,
                featureID: featureID,
                title: data.title,
                imgName: data.imgName,
                isDefaultImg: true,
                contentType: data.contentType,
                isContentRequired: data.isContentRequired,
                isEnabled: true,
                displayOrder: 255
            });
            $('#addFeatureDlg').modal('hide');
            $('#updateDlg').modal('show');
        }
        catch (error) { console.log('Add new feature error', error);  }
    });
}

const initCancelChangesDlg = () => {
    $('#btnCancelChanges').on('click', () => {

        const idx = churchFeatures.findIndex(x => x.id === churchFeature.id);
        churchFeatures[idx].imgName = origFeatureImg.imgName;
        churchFeatures[idx].imgSizeCode = origFeatureImg.imgSizeCode;
        churchFeatures[idx].isDefaultImg = origFeatureImg.isDefaultImg;
        cancelDefaultNewFeature();
        setModified(false);
        $('#editFeatureImg').val('');
        $('#divUpdDlgErrMsg').addClass('hidden');
        $('#cancelChangesDlg').modal('hide');
        $('#updateDlg').modal('hide');
    });
    $('#btnReturnToChanges').on('click', () => { $('#cancelChangesDlg').modal('hide'); });
}

const initContentTypeDDL = () => {
    $('#ddlContentType').on('change', (e) => {
        setContentTypeCtrls(parseInt(e.target.value));
    });
}

const initDeleteDlg = () => {
    $('#deleteDlg').on('show.bs.modal', (e) => {
        const key = e.relatedTarget.dataset.key;
        $('#deletePrompt').text(`Are you sure you want to delete the ${getChurchFeatureTitle(key)} feature?`);
        $('#btnDelete').off('click').click(async () => { await deleteChurchFeatureAsync({ key: key }); });
    });
}

const initResetDlg = () => {
    $('#resetDlg').on('show.bs.modal', (e) => {
        $('#btnReset').off('click').click(async () => {

            try {
                const data = await getFeatureDefaultsAsync(
                    churchFeature.featureID, churchFeature.imgSizeCode);

                $('#editTitle').val(data.title);
                $('#imgFeature').prop('src', featureImgsBaseURL + data.imgName);
                $('#editContent').val('');
                $('#cbIsEnabled').prop('checked', true);
                churchFeature.title = data.title;
                churchFeature.imgName = data.imgName;
                churchFeature.isDefaultImg = true;
                churchFeature.contentType = data.contentType;
                churchFeature.isContentRequired = data.isContentRequired;
                setModified(true);
                setHasImgsToUpload(false);
                isImgReset = true;
                $('#lblImgSizeCode,#ddlImgSizeCode').removeClass('hidden');
                $('#loader').css('display', 'none');
                $('#resetDlg').modal('hide');
            }
            catch (error) { }
        });
    });
}

const initSelectTemplateDlg = () => {

    $('#ddlTemplate').on('change', (e) => setFeatureTemplateImg(e.target.value));


    $('#selectTemplateDlg').on('show.bs.modal', (e) => {
        $('#ddlTemplate').val(featuresTemplateID);
        setFeatureTemplateImg(featuresTemplateID);
    });
    $('#btnSetTemplate').on('click', async () => {
        featuresTemplateID = parseInt($('#ddlTemplate').val(), 10);
        await savePromise({
            url: 'ChurchFeatures/Template',
            data: {
                cg: token.CG,
                id: featuresTemplateID
            },
            btnId: '#btnSetTemplate'
        })
            .then(async () => {
                $('#selectTemplateDlg').modal('hide');
                await refreshChurchFeaturesGridAsync();
            });
    });
}

const initUpdateDlg = () => {

    $('#updateDlg input[id!="editFeatureImg"],#updateDlg select')
        .on('change', () => setModified(true));

    $('.cancelChanges').on('click', () => {
        if (isDataModified() === true) {
            $('#cancelChangesDlg').modal('show');
            return;
        } else {
            cancelDefaultNewFeature();
        }
        $('#updateDlg').modal('hide');
    });

    $('#ddlImgSizeCode').on('change', async (e) => {

        try {
            const data = await getFeatureDefaultsAsync(
                churchFeature.featureID, e.target.value);

            $('#imgFeature').prop('src', featureImgsBaseURL + data.imgName);
            churchFeature.imgName = data.imgName;
            churchFeature.imgSizeCode = data.imgSizeCode;
            setModified(true);

        }
        catch (error) { }
    });

    $('#updateDlg').on('show.bs.modal', (e) => {
        const key = (e.relatedTarget === undefined)
            ? "-1"
            : e.relatedTarget.dataset.key;

        churchFeature = churchFeatures[churchFeatures.findIndex(x => x.id === key)];

        $('#updateDlgLbl').text(`Editing ${churchFeature.title} feature...`);
        $('#lblFeaturesTemplate').text('Feature Template: ' + featuresTemplate);
        $('#editTitle').val(churchFeature.title);
        origFeatureImg.imgName = churchFeature.imgName;
        origFeatureImg.imgSizeCode = churchFeature.imgSizeCode;
        origFeatureImg.isDefaultImg = churchFeature.isDefaultImg;
        if (churchFeature.imgName.length > 0) {
            $('#imgFeature').prop('src', featureImgsBaseURL + churchFeature.imgName);
        }
        churchFeature.isDefaultImg
            ? $('#lblImgSizeCode,#ddlImgSizeCode').removeClass('hidden')
            : $('#lblImgSizeCode,#ddlImgSizeCode').addClass('hidden');
        $('#ddlImgSizeCode').val(churchFeature.imgSizeCode);
        $('#ddlContentType').val(churchFeature.contentType);
        if (churchFeature.featureID === "0") { /* choose content type for custom features */
            $('#divContentType').removeClass('hidden');
            $('#btnGetResetDlg').addClass('hidden'); /* cannot reset custom feature */
        } else {
            $('#divContentType').addClass('hidden');
            $('#btnGetResetDlg')
                .attr('data-key', key)
                .removeClass('hidden');
        }
        setContentTypeCtrls(churchFeature.contentType);
        $('#editContent').val(churchFeature.content);
        $('#cbIsEnabled').prop('checked', churchFeature.isEnabled);

        $('#editFeatureImg').off('change').on('change', () => {
            uploadToImgCtrl({
                inputFileCtrl: '#editFeatureImg',
                imgCtrl: '#imgFeature',
                divErrMsg: '#divUpdDlgErrMsg',
                imgSizeErrMsg: 'A custom image must be exactly 1920x650 or 1920x1300.' +
                    '\n\rIf you need help with this, you can contact support@mysermonnotes.com',
                validImgSizes: [{ width: 1920, height: 650 }, { width: 1920, height: 1300 }],
                postOnload: (params) => {
                    uploadedImgSizeCode = params.imgSize.height === 650 ? 1 : 2;
                    $('#lblImgSizeCode,#ddlImgSizeCode').addClass('hidden');
                }

            })
            isImgReset = false;
        });


        $('#btnSave').off('click').click(async () => {

            if (hasImgsToUpload()) {
                await uploadImgToCloudAsync({
                    hasStorageParams: true,
                    imgsFolder: ImgsFolders.Features,
                    imgCtrl: '#imgFeature',
                    imgName: origFeatureImg.imgName,
                    isDefault: origFeatureImg.isDefaultImg,
                    saveAsJPEG: true,
                    url: 'Storage/Img',
                    useTestFolder: useTestFolder,
                    btnId: '#btnSave',
                    divErrMsg: 'divUpdDlgErrMsg',
                    postOnload: async (returnParams) => {
                        churchFeature.imgName = returnParams;
                        churchFeature.isDefaultImg = false;
                        churchFeature.imgSizeCode = uploadedImgSizeCode;
                        await saveFeatureAsync();
                    }
                });
            } else if (isImgReset) {
                if (origFeatureImg.isDefaultImg === false) {
                    await deletePromise({
                        hasStorageParams: true,
                        imsFolder: ImgsFolders.Features,
                        imgName: origFeatureImg.imgName,
                        isDefault: origFeatureImg.isDefaultImg,
                        url: 'Storage/Img',
                        btnId: '#btnSave',
                        divErrMsg: 'divUpdDlgErrMsg',
                    })
                }
                await saveFeatureAsync();
            } else {
                await saveFeatureAsync();
            }
        });
    });
}

const initUploadLogoDlg = () => {
    $('#uploadLogoDlg')
        .on('show.bs.modal', () => $('#imgLogo').prop('src', logoBaseURL + logoName));

    $('#editLogoImg').off('change')
        .on('change', () => uploadToImgCtrl({ inputFileCtrl: '#editLogoImg', imgCtrl: '#imgLogo' }));

    $('#imgLogo').off('error').on('error', (e) => {
        e.target.src = `${testFolderImgsBaseURL}${logoName}`;
    });

    $('#btnSaveLogo').on('click', async () => {
        await uploadImgToCloudAsync({
            hasStorageParams: true,
            imgsFolder: ImgsFolder.Logos,
            imgCtrl: '#imgLogo',
            imgName: logoName,
            isDefaultImg: false,
            saveAsJPEG: false,
            url: 'Storage/Img',
            useTestFolder: useTestFolder,
            postOnload: async (returnParams) => {
                logoName = returnParams;
                await saveChurchLogoAsync({ logoName });
                setModified(false);
                $('#uploadLogoDlg').modal('hide');

            }
        });
    });
}

const refreshChurchFeaturesGridAsync = async () => {
    try {
        const data = await getChurchFeaturesDataAsync();
        setChurchFeaturesData(data);
    }
    catch (error) { }
}

const saveFeatureAsync = async () => {

    const content = $('#editContent').val();
    const contentType = churchFeature.featureID === "0"
        ? parseInt($('#ddlContentType').val())
        : churchFeature.contentType;

    if (content.length === 0 && churchFeature.isContentRequired) {

        const contentTypeDesc =
            contentType === 1
                ? 'a website URL'
                : contentType === 2
                    ? 'an email'
                    : contentType === 3
                        ? 'a phone number'
                        : 'Error';

        $("#divUpdDlgErrMsg").text(`Please enter ${contentTypeDesc} for this feature.`).removeClass('hidden');
        return;
    }

    if (contentType === 1 && churchFeature.isContentRequired) {
        if (!validURL({ urlCtrl: 'editContent' })) {
            $("#divUpdDlgErrMsg").text("Please enter a properly formatted url.").removeClass('hidden');
            return;
        }
    } else if (contentType === 2) {
        if (!validEmail({ emailCtrl: 'editContent' })) {
            $("#divUpdDlgErrMsg").text("Please enter a properly formatted email address.").removeClass('hidden');
            return;
        }
    }

    if (appDebugMode) {
        //console.log('churchFeature before save');
        //console.log(churchFeature);
    }

    await savePromise({
        url: 'ChurchFeatures',
        data: {
            id: churchFeature.id,
            cg: `${token.CG}`,
            featureID: churchFeature.featureID,
            title: $('#editTitle').val(),
            imgName: churchFeature.imgName,
            imgSizeCode: churchFeature.imgSizeCode,
            isDefaultImg: churchFeature.isDefaultImg,
            contentType: contentType,
            content: content,
            isContentRequired: churchFeature.isContentRequired,
            isEnabled: $('#cbIsEnabled').is(':checked')
        },
        btnId: '#btnSave',
        divErrMmg: 'divUpdDlgErrMsg'
    })
    .then(async () => {
        await refreshChurchFeaturesGridAsync();
        $('#updateDlg').modal('hide');
    });
}

const setChurchFeaturesData = (data) => {
    churchFeatures = data.churchFeatures;
    featureImgsBaseURL = data.featureImgsBaseURL;
    featuresTemplate = data.featuresTemplate;
    featuresTemplateID = data.featuresTemplateID;
    logoBaseURL = data.logoBaseURL;
    logoName = data.logoName;
    getTableRows({ arr: churchFeatures, fnGetRow: getChurchFeatureRow, gridNm: 'gridFeatures' });
    setModified(false);
}

const setContentTypeCtrls = (contentType) => {
    let lblText = "Error";
    switch (contentType) {
        case 1:
            lblText = "Website URL";
            $('#editContent')
                .attr('placeholder', 'mychurch.org')
                .off('input');
            break;
        case 2:
            lblText = "Email";
            $('#editContent')
                .attr('placeholder', 'support@mychurch.org')
                .off('input');
            break;
        case 3:
            lblText = "Phone Number";
            $('#editContent')
                .attr('placeholder', '(999) 999-9999')
                .off().on('input', phoneNumberInputMask());
            break;
    }
    $('#lblContent').text(lblText);
};

const setFeatureTemplateImg = (featureID) =>
    $('#featureTemplateImg').attr('src', featureImgsBaseURL +
        featuresTemplates[featuresTemplates.findIndex(x => x.id === featureID)].PhoneImgName);

let churchFeature = {};
let churchFeatures = [];
let featureImgsBaseURL = "";
let features = [];
let featuresTemplate = "";
let featuresTemplateID = 1;
let featuresTemplates = [];
let isImgReset = false;
let logoBaseURL = "";
let logoName = "";
let origFeatureImg = {};
let testFolderImgsBaseURL = "";
let uploadedImgSizeCode = 0;

const initAsync = async () => {
    window.onbeforeunload = () => {
        if (isDataModified() === true) {
            return "Your changes have not been saved...";
        }
    };
    setMenu();
    initAddFeatureDlg();
    initCancelChangesDlg();
    initContentTypeDDL();
    initDeleteDlg();
    initResetDlg();
    initSelectTemplateDlg();
    initUpdateDlg();
    initUploadLogoDlg();

    const [featuresData, featuresTemplatesData, churchFeaturesData, tImgsBaseURL] =
        await allSettled({
            promises: [
                getFeaturesDataAsync(),
                getFeaturesTemplatesDataAsync(),
                getChurchFeaturesDataAsync(),
                getImgsBaseURLAsync(ImgsFolder.TestFolder)
            ]
        });
    if (churchFeaturesData.status !== 'rejected') {
        setChurchFeaturesData(churchFeaturesData.value);
    };

    if (featuresData.status !== 'rejected') {
        features = featuresData.value;
    };

    if (featuresTemplatesData.status !== 'rejected') {
        featuresTemplates = featuresTemplatesData.value;
        bindSelect({
            id: 'ddlTemplate', items: featuresTemplates, valueNm: 'id', textNm: 'description'
        });
    };
    if (tImgsBaseURL.status !== 'rejected') {
        testFolderImgsBaseURL = tImgsBaseURL.value;
    };

    initDragDropTableSort({
        selector: '#gridFeatures > tbody',
        fnStop: async () => {
            await savePromise({
                url: 'ChurchFeatures/Sort',
                data: {
                    cg: token.CG,
                    sortKeys: getSortKeysFromTableOrder({
                        selector: '#gridFeatures > tbody > tr'
                    })
                }
            })            
        }
    });
};

window.snFeatures = {
    initAsync
};
